import { HTMLAttributes } from 'react'
import Link from 'next/link'

import Button from '@/components/base/Button'
import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Typography from '@/components/base/Typography'
import TypographyMask from '@/components/base/TypographyMask'

import { opacityReveal } from './animations/opacity'
import { cn } from '@/lib/utils'
import { WPLink } from '@/types'

export type BlocksProps = HTMLAttributes<HTMLElement> &
  Partial<{
    items: {
      title: string
      description: string
      link: WPLink
    }[]
  }>

const Blocks = ({ items }: BlocksProps) => {
  return (
    <Motion animation={opacityReveal}>
      <section data-blocks>
        <Container>
          <Grid className="gap-y-[30px]">
            {items?.map((item, index) => (
              <div
                key={index}
                className={cn(
                  'bg-[#F0F2F5] px-[15px] py-[30px]',
                  'flex flex-col gap-[15px]',
                  'col-span-4 md:col-span-3 lg:col-span-4',
                  {
                    'lg:col-start-5':
                      items.length % 3 === 1 &&
                      index === items.length - 1 &&
                      items.length > 2,
                    'lg:col-start-3':
                      items.length % 3 === 2 &&
                      index === items.length - 2 &&
                      items.length > 2
                  }
                )}
              >
                {item.title ? (
                  <div className="flex">
                    <Typography variant="h6">{item.title}</Typography>
                  </div>
                ) : null}
                {item.description ? (
                  <div className="flex">
                    <Typography variant="body">{item.description}</Typography>
                  </div>
                ) : null}
                {item.link ? (
                  <div className="mt-[15px] flex">
                    {item.link && (
                      <Button variant="primary" asChild>
                        <Link
                          href={item?.link?.url || ''}
                          className={cn('mt-[30px] self-start')}
                          data-only-text-link
                          scroll={false}
                        >
                          <TypographyMask>
                            <span>{item.link.title}</span>
                          </TypographyMask>
                        </Link>
                      </Button>
                    )}
                  </div>
                ) : null}
              </div>
            ))}
          </Grid>
        </Container>
      </section>
    </Motion>
  )
}

export default Blocks
